export { r as rubberbandIfOutOfBounds } from '../../dist/maths-b2a210f4.esm.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@use-gesture/core/utils/dist/use-gesture-core-utils.esm.js
// module id = 1026
// module chunks = 10